export const LOADING_KEYS = {
  ASSESSMENT_NOTE: "assessmentNote",
  INDIVIDUAL_PATIENT: "individualPatient",
  TREATMENT_KEY: "treatmentKey",
  WOUND_EVENTS_ACTIVITY_LOG: "woundEvent",
  ADT_EVENTS_ACTIVITY_LOG: "adtEvents",
  VIEW_EVENTS_ACTIVITY_LOG: "viewEvent",
  DELETE_ASSESSMENT_NOTE: "deleteAssessmentNote",
  CREATE_NOTE: "CREATE_NOTE",
  UPDATE_NOTES: "UPDATE_NOTES",
  INTERVENTION_TREATMENT: "interventionTreatment",
  HEALING_TRAJECTORY: "healingTrajectory",
  PATIENT_V1: "PATIENT_V1",
  PATIENT_REFUSAL_REASON: "PATIENT_REFUSAL_REASON",
  GET_ASSESSMENT_HISTORY: "GET_ASSESSMENT_HISTORY",
  GET_CONSOLIDATE_PDF: "GET_CONSOLIDATE_PDF",
  GET_MINIMUM_DATASET_INFO: "GET_MINIMUM_DATASET_INFO",
  SIGN_LOCK_LOADING: "SIGN_LOCK_LOADING",
  // Report
  QUALITY_ASSURANCE_REPORT: "qualityAssuranceReport",
  QUALITY_ASSURANCE__CSV_REPORT: "qualityAssuranceCsvReport",
  TREATMENT_REPORT: "treatmentReport",
  TREATMENT_CSV_REPORT: "treatmentCsvReport",
  WOUND_DASHBOARD_ASSESSMENT: "woundDashboardAssessment",
  QUALITY_ASSURANCE_OVERVIEW: "qualityAssuranceOverview",
  CSV_EXPORT: "csvExport",
  BI_REPORT_LIST: "biReportList",
  NEW_ADDMISSION_POA: "newAdmissionPOA",
  NEW_ADDMISSION_NONPOA: "newAdmissionNonPOA",
  NEW_WOUNDS_POA: "newWoundsPoa",
  NEW_WOUNDS_NON_POA: "newWoundsNonPoa",
  PI_ASSESSMENT_POA: "piAssessmentPOA",
  PI_ASSESSMENT_NON_POA: "piAssessmentNonPOA",
  OTHER_ASSESSMENT_POA: "OTHER_ASSESSMENT_POA",
  OTHER_ASSESSMENT_NON_POA: "OTHER_ASSESSMENT_NON_POA",
  WOUND_EXPERT_ASSESSMENT_POA: "WOUND_EXPERT_ASSESSMENT_POA",
  WOUND_EXPERT_ASSESSMENT_NON_POA: "WOUND_EXPERT_ASSESSMENT_NON_POA",
  WOUND_EXPERT_ASSESSMENT_DEBRIDEMENT: "WOUND_EXPERT_ASSESSMENT_DEBRIDEMENT",
  COMPLETED_ASSESSMENT: "COMPLETED_ASSESSMENT",
  WOUND_PHOTO_WORKLIST: "WOUND_PHOTO_WORKLIST",
  SURVERY_RESULTS: "SURVERY_RESULTS",
  USER: "USER",
  SSO_TENANT_LIST: "SSO_TENANT_LIST",
  GET_FORMULARY: "GET_FORMULARY",
  GET_LAYOUTS: "GET_LAYOUTS",
  GET_CUSTOM_FORM: "GET_CUSTOM_FORM",
  GET_CUSTOMER: "GET_CUSTOMER",
  GET_SUPPORT: "GET_SUPPORT",
  GET_ANNOUNCEMENT: "GET_ANNOUNCEMENT",
  GET_ASSIGNED_FORMULARY: "GET_ASSIGNED_FORMULARY",
  GET_CUSTOMER_USERS: "GET_CUSTOMER_USERS",
};
